import React, { useEffect, useRef, useState } from 'react';
import { evaluatePasswordRules } from '../utils/bayilikBasvuruPassword';
import './BayilikSifreGereksinimleri.css';

const BayilikSifreGereksinimleri = ({ password, visible, onFocus, onBlur, children }) => {
  const wrapRef = useRef(null);
  const [open, setOpen] = useState(false);
  const blurTimerRef = useRef(null);

  const showPanel = visible && open;
  const rules = evaluatePasswordRules(password);

  useEffect(() => () => {
    if (blurTimerRef.current) clearTimeout(blurTimerRef.current);
  }, []);

  const handleFocus = (e) => {
    if (blurTimerRef.current) clearTimeout(blurTimerRef.current);
    setOpen(true);
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    blurTimerRef.current = setTimeout(() => {
      if (wrapRef.current && !wrapRef.current.contains(document.activeElement)) {
        setOpen(false);
      }
    }, 120);
    onBlur?.(e);
  };

  return (
    <div className="bayilik-sifre-wrap" ref={wrapRef}>
      {React.cloneElement(children, {
        onFocus: (e) => {
          handleFocus(e);
          children.props.onFocus?.(e);
        },
        onBlur: (e) => {
          handleBlur(e);
          children.props.onBlur?.(e);
        },
      })}
      {showPanel && (
        <div className="bayilik-sifre-panel" role="status" aria-live="polite">
          <ul className="bayilik-sifre-rules">
            {rules.map((rule) => (
              <li key={rule.id} className={rule.passed ? 'passed' : 'failed'}>
                <i
                  className={`fas ${rule.passed ? 'fa-check' : 'fa-times'}`}
                  aria-hidden="true"
                />
                <span>{rule.label}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default BayilikSifreGereksinimleri;
